import { Component, OnInit } from '@angular/core';
import { ChartData, ChartOptions } from 'chart.js';
import { ChartModule } from 'primeng/chart';
import SampleProcessLogStats from '../../../../../types/stats/SampleProcessLogStats';
import { StatsService } from '../../../services/stats.service';

@Component({
    selector: 'app-sample-process-log-chart',
    imports: [ ChartModule ],
    templateUrl: './sample-process-log-chart.component.html',
    styleUrl: './sample-process-log-chart.component.scss'
})
export class SampleProcessLogChartComponent implements OnInit {

    public data: ChartData | undefined;
    public options: ChartOptions | undefined;

    constructor(private statsService: StatsService) {
    }

    /**
     * Initializes the component.
     */
    public ngOnInit() {
        this.initChart();
    }

    /**
     * Initializes the chart. Fetches process log stats and sets up the chart data and options.
     */
    private initChart() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--p-text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
        const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

        this.statsService.getProcessLogStats().then((processLogStats: SampleProcessLogStats) => {
            // Sort labels by date
            const logs = Object.entries(processLogStats.logsPerDay)
                .sort(([ dateA ], [ dateB ]) => new Date(dateA).getTime() - new Date(dateB).getTime());

            // Extract sorted labels and data
            const labels = logs.map(([ date ]) => date);
            const data = logs.map(([ , count ]) => count);

            // Filter labels to show only every 10th label
            const filteredLabels = labels.map((label, index) => ( index % 10 === 0 ? label : '' ));

            this.data = {
                labels: filteredLabels, // Use filtered labels
                datasets: [
                    {
                        label: 'Daily process logs',
                        data,
                        borderColor: documentStyle.getPropertyValue('--p-primary-color'),
                        tension: 0.4,
                        pointRadius: 0,
                    },
                ],
            };

            this.options = {
                maintainAspectRatio: false,
                aspectRatio: 1,
                plugins: {
                    legend: {
                        labels: {
                            color: textColor,
                        },
                    },
                },
                scales: {
                    x: {
                        ticks: {
                            color: textColorSecondary,
                            callback: function (value, index) {
                                // Render only non-empty labels
                                return filteredLabels[index] || null;
                            },
                        },
                        grid: {
                            color: surfaceBorder,
                        },
                    },
                    y: {
                        ticks: {
                            color: textColorSecondary,
                            precision: 0,
                        },
                        grid: {
                            color: surfaceBorder,
                        },
                    },
                },
            };
        });
    }

}